// extracted by mini-css-extract-plugin
export default {"spot-card":"SpotCard_spot-card__MtvbQ","spot-card-image":"SpotCard_spot-card-image__+byAh","spot-card-badge":"SpotCard_spot-card-badge__tNmak"};